<section class="business_profile" >
    <div class="bus_profile_card" *ngIf="!loader && _entityDetails.length > 0">
        <div class="row" style=" margin-bottom: 32px;align-items: center;">
            <div class="col-8">
        <div class="welcome_heading" >
            <h3>Business profile</h3>
         </div>
        </div>
        <!-- (click)="createNewBusiness()" -->
        <div class="col-4">
         <div class="create_btn_sd">
            <button mat-icon-button color="primary" (click)="selectcountry()">
                <mat-icon>add</mat-icon> 
            </button>
        </div>
        </div>
    </div>

<div class="row">
    <div class="col-sm-6 col-md-6 col-12" *ngFor="let item of _entityDetails">
        <div class="salon_mei_sectionx ">
            <mat-card appearance="outlined" (click)="openBusinessDetails(item)">
               <div class="exert_opd">
                <div class="active_busn" *ngIf="item.isActive == 0 || !item.subscriptionInfo || item.subscriptionInfo == 'null'">
                    
                </div>
                <div class="active_send" *ngIf="item.isActive == 1 && item.subscriptionInfo && item.subscriptionInfo != 'null'">
                    
                </div>
            <div class="salon_img">
                <img [src]="item.default_image?.image_thumb_url" onerror="this.src='../../../../assets/images/entity_placeholder.png'" alt="" *ngIf="item.revenue_model == 1">
                <img [src]="item.default_image?.image_thumb_url" onerror="this.src='../../../../assets/images/fitness-placeholder.png'" alt="" *ngIf="item.revenue_model == 2">
            </div>
            <div class="hair_ct_heading">
                <h4  style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{item.entityName}}</h4>
                <p style="white-space: nowrap;overflow: hidden; text-overflow: ellipsis;"> Service: {{item.entity_services | servToStr}}</p>
                <p style="white-space: nowrap;overflow: hidden; text-overflow: ellipsis;"> {{item.addressInfo.address_line}}
                </p>
                <p>{{item.entityCountryCode}} {{item.entityPhone}}</p>
            </div>
          <div class="desc_box">
                <p>Created on: {{item.creation_date | date}}</p>
            </div>
         </div>
         <div class="onhover_arrow">
            <mat-icon class="hover-icon"> arrow_forward</mat-icon>
       </div>
        </mat-card>
        </div>
       </div>
</div>
</div>

<!-- Placeholder design html start -->
  <div class="placeholder_started" *ngIf="!loader && _entityDetails.length == 0">
    <div class="row">
        <div class="col-sm-5">
    <div class="welcome_heading" style="margin-bottom: 30px;">
        <h3>Business profile</h3>
     </div>
    </div>
</div>
        <div class="row">
          <div class="col-sm-6 col-md-6 col-12">
            <div class="dashboard_new">
              <mat-card appearance="outlined">
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/business-create.png" style="width: 110px;">
                 </div>
                 <mat-card-title>No business added yet</mat-card-title>
                 <mat-card-content>Start your journey with creating a new business or professional service. Once you add one, it will appear here.
                </mat-card-content>
                 <div class="create_btnyh">
                    <button mat-flat-button color="primary" (click)="selectcountry()">
                        <mat-icon>add</mat-icon> 
                        Create a business
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-6 col-md-6 col-12">
            <div class="dashboard_new">
              <mat-card appearance="outlined">
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/create-business.png">
                 </div>
                 <mat-card-title>How to create a business?</mat-card-title>
                 <mat-card-content>Check our <span class="ghtunderline" (click)="openLink('https://lookzup.com/help')"> help document </span> on creating a new business or professional service. You can check this video as well. 
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" (click)="openvideo()">
                       <mat-icon>play_arrow</mat-icon>
                       Watch video
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
          <div class="col-sm-6 col-md-6 col-12">
            <div class="dashboard_new">
              <mat-card appearance="outlined">
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/helpsupport.png">
                 </div>
                 <mat-card-title>Facing any issue?</mat-card-title>
                 <mat-card-content>For any difficulties in creating a new business or if there's any issue with subscription, contact our support team. 
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary"  (click)="opencontact()">
                       <mat-icon>support_agent</mat-icon>
                       Contact support 
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
        </div>
      </div> 
</section>